import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ProposalPage from "../pages/proposal/page";
import AdminTemplatePage from "../pages/admin/template/page";
import AdminProposalsPage from "../pages/admin/proposals/page";
import ProposalFormPage from "../pages/admin/proposals/ProposalFormPage";
import AdminLoginPage from "../pages/admin/login/page";
import AdminDashboardPage from "../pages/admin/dashboard/page";
import AdminLibraryPage from "../pages/admin/library/page";
import AdminRoute from "../components/AdminRoute";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/proposta/:token",
    element: <ProposalPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLoginPage />,
  },
  {
    path: "/admin/dashboard",
    element: (
      <AdminRoute>
        <AdminDashboardPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/template",
    element: (
      <AdminRoute>
        <AdminTemplatePage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/library",
    element: (
      <AdminRoute>
        <AdminLibraryPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/proposals",
    element: (
      <AdminRoute>
        <AdminProposalsPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/proposals/new",
    element: (
      <AdminRoute>
        <ProposalFormPage />
      </AdminRoute>
    ),
  },
  {
    path: "/admin/proposals/edit/:id",
    element: (
      <AdminRoute>
        <ProposalFormPage />
      </AdminRoute>
    ),
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;